import { ReplenishmentTemplateCategoryUpdatePage } from '@/features/replenishment-template-category/pages/ReplenishmentTemplateCategoryUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/replenishment-template-category/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["replenishment_template_category.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ReplenishmentTemplateCategoryUpdatePage,
});
